// extracted by mini-css-extract-plugin
var _1 = "UserMultiValueContentLinked-modulelink__wBWq3";
var _2 = "UserMultiValueContentLinked-moduletext__WoZ4t";
export { _1 as "link", _2 as "text" }
